import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <div className="contact container" id="contacts">
      <div className="row">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <h1>Contact Me</h1>
          <div className="contact__border"></div>
          <p className="my-5 text-justify">
            My inbox is always open. In case of any queries you can drop me a
            message at any of the links below. I will try to respond as soon as
            possible.
          </p>
          <div className="contact__icon">
            <a
              href="mailto:anum.mujahid.se@gmail.com"
              className="contacticon__envelope"
            >
              <i className="far fa-envelope"></i>
            </a>
            <a
              href="https://github.com/AnumMujahid/"
              className="contacticon__github"
            >
              <i className="fab fa-github"></i>
            </a>
            <a
              href="https://www.instagram.com/anum_mujahid/"
              className="contacticon__instagram"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://twitter.com/mujahid_anum"
              className="contacticon__twitter"
            >
              <i className="fab fa-twitter"></i>
            </a>
            <a
              href="https://www.facebook.com/anum.mujahid.10297"
              className="contacticon__facebook"
            >
              <i className="fab fa-facebook"></i>
            </a>
            <a
              href="https://www.linkedin.com/in/anum-mujahid-full-stack-developer/"
              className="contacticon__linkedin"
            >
              <i className="fab fa-linkedin"></i>
            </a>
          </div>
          <p className="mb-5 contact__footer">
            Designed and Developed by Anum Mujahid
          </p>
        </div>
        <div className="col-12 col-md-2"></div>
      </div>
    </div>
  );
}

export default Contact;
